import { css, keyframes } from 'styled-components';
const pulseRing = keyframes(["0%{transform:scale(0.33);opacity:1;}33%{transform:scale(0.66);opacity:0.8;}66%{transform:scale(1);opacity:0.4;border-width:8px;}100%{opacity:0;border-width:2px;}"]);
const hotspotAnimation = css(["", " 2s infinite"], pulseRing);
export default hotspotAnimation;